import {PALETTE} from 'shared/config/model/palette';

import {isTranslate} from './lang';

export const colorMonitorPingMessage = (code: number): string => {
    switch (true) {
        case code >= 200 && code < 300:
            return PALETTE.success;
        case code >= 300 && code < 400:
            return PALETTE.warning;
        case code === 0:
        case code >= 400:
            return PALETTE.error;
        default:
            return PALETTE.neutral;
    }
};

export const colorIncidentStatus = (resolved: boolean): string => {
    return resolved ? PALETTE.success : PALETTE.error;
};

export const brandColor = (ru: string, en: string): string => (isTranslate() ? en : ru);

export const SERVER_METRICS_CHART_COLORS = [
    PALETTE.accentSecondary,
    PALETTE.accent,
    PALETTE.chartAmber,
    PALETTE.accentEn,
];
